<template>
  <div class="footer">
    <div>
      <div class="footer_title">
        <div class="line"></div>
        <div>联系我们</div>
      </div>
      <p>深圳市德力诚信科技有限公司 <a id="beian" href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2021152175号-1</a></p>
      <p>公司电话：18116179873</p>
      <p>联系人：刘经理</p>
    </div>
    <div>
      <div class="footer_title">
        产品中心
      </div>
        <p>
          <router-link to="/Home/JC">样线制作</router-link>
        </p>
        <p>
          <router-link to="/Home/NB">PCBA加工</router-link>
        </p>
        <p>
          <router-link to="/Home/UPR">连接器定制</router-link>
        </p>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>

<style scoped>

</style>